<div class="wrapper__headerComponent container my-5">
  <div class="row align-items-center">
    <div class="col-12 col-md-3"></div>
    <div class="col-12 col-md-6">
      <h2 class="text-center h3-tipografia-govco mb-0">
        {{"gestion-expediente" | translate}}
      </h2>
    </div>
  </div>
</div>
<div class="wrapper__contentComponent--expediente container my-5">
  <div class="d-flex flex-row justify-content-end mb-5">
    <div>
      <a
        id="crearSolicitud"
        class="btn-govco outline-btn-govco hvr-shrink"
        routerLink="/tramites"
        ><span class="govco-plus-square-1"></span>
        {{"presentar-demanda" | translate}}
      </a
      >
    </div>
  </div>
  <div class="contenedor-tabla w-100">
      <app-table
      id="historico"
      (evento)="buscar($event)"
      [datos]="expedientes"
      [paginaActual]="paginaActual"
      [columnas]="columns"
      [acciones]="actions"
      [paginacion]="true"
      [tamano]="tamanoPagina"
      [totalPaginas]="totalPaginas"
      [tamanos]="[1, 5, 10, 20]"
      (eventoAccion)="gestionPermisos($event)"></app-table>
  </div>
</div>
<app-politica-tratamiento-datos-personales></app-politica-tratamiento-datos-personales>
